import ButtonBase from "./ButtonBase";
import styles from "./ButtonSuccess.css";

const ButtonDelete = (props) => {
  const { children, ...rest } = props;
  const classes = styles();

  return (
    <ButtonBase {...rest} className={classes.button} variant="contained">
      {children}
    </ButtonBase>
  );
};

export default ButtonDelete;
